export const MINI_DRAWER_WIDTH = 84; // px